import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
import ListMenuHeader from './ListMenuHeader';
const ListMenuGroup = ({ menuGroup, className }) => {
    if (!menuGroup.navItems.length) {
        return null;
    }
    return (_jsxs("ul", Object.assign({ className: `ListMenuGroup ${className}` }, { children: [_jsx(ListMenuHeader, Object.assign({}, menuGroup)), menuGroup.navItems.map(item => (_jsx("li", Object.assign({ className: classNames({ disabled: item.disabled, subitem: item.isSubItem }) }, { children: item.item }), item.key)))] })));
};
export default ListMenuGroup;
